import { ACTION_SET_CHECKOUT_STEP } from './types'

const setCheckoutStep = (container, payload) => ({
    payload,
    type: ACTION_SET_CHECKOUT_STEP,
})

export default setCheckoutStep
